module.exports = __webpack_public_path__ + "media/cases/cta-4d5ad645.jpg";